import { Box, Typography } from '@mui/material'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import { useTranslation } from 'react-i18next'

import ParticipantCard from 'components/ParticipantProfile/ParticipantCard'

const HelpText = () => {
  const { t } = useTranslation()
  const color = 'rgba(0,0,0, 0.6)'

  const groupDetails = ['detailOne', 'detailTwo', 'detailThree']

  return (
    <ParticipantCard>
      <Box display="flex" alignItems="center">
        <LightbulbOutlinedIcon sx={{ marginRight: 1, color }} />
        <Typography variant="h5">
          {t('participantProfile.helperText.didYouKnow')}
        </Typography>
      </Box>
      <Box sx={{ color }}>
        <Typography variant="body2" mt={3}>
          {t('participantProfile.helperText.profileDetail')}
        </Typography>

        <Typography variant="body2" mt={2}>
          {t('participantProfile.helperText.groupsDetail')}
          <Box component="ul" my="0">
            {groupDetails.map((detail) => (
              <Box key={detail} component="li">
                {t(`participantProfile.helperText.${detail}`)}
              </Box>
            ))}
          </Box>
        </Typography>
      </Box>
    </ParticipantCard>
  )
}

export default HelpText
